import { css } from '@emotion/css';
import { breakpoints } from '@/css/resources/variables.css';

const getStyles = () =>
	css({
		'&.supt-imageResponsive--has-mobile-image': {
			'.supt-imageResponsive__imageWrapper--desktop': {
				display: 'none',
			},
			'.supt-imageResponsive__imageWrapper--mobile': {
				display: 'block',
			},

			[`@media (min-width: ${breakpoints.tablet})`]: {
				'.supt-imageResponsive__imageWrapper--desktop': {
					display: 'block',
				},
				'.supt-imageResponsive__imageWrapper--mobile': {
					display: 'none',
				},
			},
		},
	});

export { getStyles };
